import { LayerStyles } from "types/types";

export const deleteLayerStyle: LayerStyles = {
  color: "red",
  fillColor: "red",
  fillOpacity: 0.8,
  weight: 2,
};

export const editLayerStyle: LayerStyles = {
  color: "yellow",
  fillColor: "yellow",
  fillOpacity: 0.8,
  weight: 2,
};

export const basePolygonLayerStyle: LayerStyles = {
  fillOpacity: 0.4,
  weight: 2,
};

export const basePointLayerStyle: LayerStyles = {
  fillOpacity: 1,
  weight: 0,
};
